import { createBaseQueryWithReauth } from '@/services';
import { API_ATC_URL } from '@/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

export const customerServiceApi = createApi({
  reducerPath: 'customerServiceApi',
  baseQuery: createBaseQueryWithReauth(API_ATC_URL),
  endpoints: () => ({}),
  tagTypes: [
    'Cases',
    'Case',
    'Images',
    'CaseSubscription',
    'CaseFrequency',
    'CaseOptions',
    'CaseInterventions',
    'CasesInformation',
    'CasesByBusiness',
    'CasesByIssuesWeek',
    'CasesByResolutionTime',
    'CasesOverview',
    'Minutes',
    'Minute',
    'Invoices',
    'CaseDestinations',
    'CaseProducts',
  ],
});
